import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavigationBar from "./components/NavigationBar";
// import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import CharacterCounterPage from "./pages/CharacterCounterPage";
import AboutPage from "./pages/AboutPage";

import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import ProfilePage from "./pages/ProfilePage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
 


const CharacterCounter = () => <CharacterCounterPage />;
const Contact = () => <ContactPage />;
const About = () => <AboutPage />;

function App() {
  return (
    <Router>
      <NavigationBar />
      <div className="container mt-4">
        <Routes>
          <Route exact path="/" element={<CharacterCounter />} />
          <Route
            exact
            path="/character-counter"
            element={<CharacterCounter />}
          />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/about" element={<About />} />

          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
